export default __webpack_public_path__ + "static/logo-0007848cceecf54806ce508edb5fda61.svg";